import { render, staticRenderFns } from "./tipoServico.vue?vue&type=template&id=3aaa8333&"
import script from "./tipoServico.vue?vue&type=script&lang=js&"
export * from "./tipoServico.vue?vue&type=script&lang=js&"
import style0 from "./tipoServico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports